import { useQuery } from 'react-query';
import { EXPRESS_API } from '../../configs/api/expressApi';
import { GetInventoryParams, InventoryParams } from '../types';

export const getInventoryItems = async (params: GetInventoryParams) => {
  return (await EXPRESS_API.get(`/inventory`, { params })).data;
};

export const useGetInventoryItems = ({
  size = 10,
  page = 0,
  sort = '',
  searchQuery = '',
  soldFilter = '',
  videosRecordedFilter = '',
  countRecorded = false,
  enabled = true,
}: InventoryParams) => {
  return useQuery(
    [
      'inventoryItems',
      size,
      page,
      sort,
      searchQuery,
      soldFilter,
      videosRecordedFilter,
      enabled,
      countRecorded,
    ],
    async () =>
      getInventoryItems({
        limit: size,
        start: page * size,
        sort,
        search: searchQuery || '',
        soldFilter,
        videosRecordedFilter,
        countRecorded,
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: !countRecorded ? 3600000 : 0, // 1 hour if video counter not necessary
      enabled,
    }
  );
};
